export function injectScript(src, id) {
  if (!document.getElementById(id)) {
    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;
    document.head.appendChild(script);
  }
}